export const columnsQueryKeys = {
  derivedColumnPreview: (tableId: string, formula: string, recordId: string) =>
    ['derived-columns', tableId, 'preview', formula, recordId] as const,
  formulaValidation: (tableId: string, formula: string) =>
    ['formulas', tableId, 'validate', formula] as const,
  formulaFieldSearchAll: ['formula-fields'] as const,
  formulaFieldSearch: (query: string) => ['formula-fields', query] as const,
}
